import React from "react";
import { Box } from "@mui/material";
import IndexCard from "../../../shared/IndexCard/IndexCard";
import { Link, useOutletContext } from "react-router-dom";
import PaginatedListLayout from "../../../../shared/pagination/PaginatedListLayout";

const ProjectListPage = () => {
  const {
    contractExists,
    isActive,
    projects,
    loading,
    hasSearchFilters,
    handleMarkedRead,
    hasExecutedSearch,
    isSearching,
    pagination,
    goToPage,
  } = useOutletContext();

  const openProjects = projects;
  // id が新しい順（降順）に並べた表示用配列
  // const projectsSortedByIdDesc = useMemo(() => {
  //   return [...projects].sort((leftProject, rightProject) => {
  //     return rightProject.id - leftProject.id;
  //   });
  // }, [projects]);

  // 検索に一致する結果がない場合のメッセージ
  const shouldShowNoResultsMessage =
    hasExecutedSearch && hasSearchFilters && !isSearching;

  const emptyText = shouldShowNoResultsMessage
    ? "検索条件と一致する結果が見つかりません。"
    : [
        "現在、公開中のプロジェクトはありません。",
        "お問い合わせ内容をもとに、条件に合うプロジェクトをご案内できる場合があります。",
        "お問い合わせフォームよりお気軽にご連絡ください。",
      ].join("\n");

  // loading中やデータが0件のときは map を実行しない
  const shouldRenderProjects = !loading && openProjects.length > 0;

  return (
    <Box sx={{ maxWidth: 960, mx: "auto" }}>
      <PaginatedListLayout
        items={openProjects}
        loading={loading}
        pagination={pagination}
        onPageChange={goToPage}
        emptyText={emptyText}
      >
        {shouldRenderProjects && (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: { xs: 1, sm: 2 },
            }}
          >
            {openProjects.map((project) => (
              <IndexCard
                key={project.id}
                item={project}
                type="project"
                component={Link}
                to={`/projects/${project.id}`}
                onMarkedRead={handleMarkedRead}
                contractExists={contractExists}
                isActive={isActive}
              />
            ))}
          </Box>
        )}
      </PaginatedListLayout>
    </Box>
  );
};

export default ProjectListPage;
